@if (loadingOverlay.isLoading()) {
  <div class="loading-overlay" role="status" aria-live="polite" aria-label="Cargando">
    <div class="loading-overlay__content">
      <img [src]="logoUrl" alt="Autodromo" class="loading-overlay__logo" />
    </div>
  </div>
}
